export default async function ({ $auth }) {
  if (!process.server) {
    await $auth.fetchUser();
  }
}
